import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { subscribe, unsubscribe } from '../../../shared/api/socketLogistic';
import { stateLogisticTasksResourceActions } from '../../../entities/logistic/logisticTasks/redux/socketLogisticTasks.slice';
import { logisticTasksBalanceResourceActions } from '../../../entities/logistic/logisticTasks/redux/logisticTasksBalance.slice';

function LogisticSocket({ children, id }) {
  const subscriberRef = useRef(null);

  const topic = useMemo(() => `/topic/logistic-state/${id}`, [id]);

  const dispatch = useDispatch();

  const subscribeToTopic = useCallback(async () => {
    subscriberRef.current = await subscribe(topic, (data) => {
      if (data.state) {
        const res = JSON.parse(`${data.state}`);

        dispatch(stateLogisticTasksResourceActions.setData(res));
        dispatch(
          logisticTasksBalanceResourceActions.setData({ stateData: { logisticTaskStateId: id, stateMap: res } }),
        );
      }
    });
  }, [topic, subscribe]);

  useEffect(() => {
    if (id) subscribeToTopic();

    return () => {
      unsubscribe(subscriberRef.current, topic);
      dispatch(stateLogisticTasksResourceActions.reset());
    };
  }, [id, subscribeToTopic]);

  return children;
}

export default LogisticSocket;
